import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions/clubActions';
import * as memberActions from '../../actions/memberActions';

class ClubPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillMount = this.componentWillMount.bind(this);
  }

  componentWillMount() {
    if(this.props.clubId) {
      this.props.actions.loadClubDetails(this.props.clubId);
    }
  }

  render() {
    return (this.props.children);
  }
}

ClubPage.propTypes = {
  actions: PropTypes.object.isRequired,
  clubId: PropTypes.string,
  clubDetails: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.element,
  ]),
};

function mapStateToProps(state, ownProps) {
  return {
    clubId: ownProps.params.clubId,
    clubDetails: state.clubs.clubDetails,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    memberActions: bindActionCreators(memberActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClubPage);



/** WEBPACK FOOTER **
 ** ./src/containers/clubs/ClubPage.js
 **/